<template>
  <div>
    <b-card no-body class="bdr-tabs">
      <b-tabs card>
        <b-tab title="Сводная таблица" active>
          <b-card-text>
            <div class="bdr-results-head bdr2026-results-head">
              <div><h5>Бюджет за {{ selected.year }} год</h5></div>
              <div class="bdr-results-head-selects bdr2026-head-controls">
                <b-button
                  @click="getBDR()"
                  size="sm"
                  variant="outline-secondary"
                  class="bdr2026-head-btn-icon"
                  :disabled="loading"
                >
                  <b-icon icon="arrow-repeat" scale="1.5" aria-label="Reload" :animation="loading ? 'spin' : ''"></b-icon>
                </b-button>
                <b-form-select
                  v-model="selected.unit"
                  :options="unitOptions"
                  size="sm"
                  class="bdr2026-head-select custom-select-height-small"
                  @change="getBDR"
                  :disabled="loading"
                />
                <b-form-select
                  v-model="selected.year"
                  :options="yearList"
                  size="sm"
                  class="bdr2026-head-select custom-select-height-small"
                  :disabled="loading"
                  @change="getBDR"
                />
                <button
                  class="ml-2 bdr-results-button bdr2026-export-btn"
                  style="height: 30px; min-width: 37px;"
                  :disabled="loading || bdr.length === 0"
                  @click="exportTable('bdr2026-result-table', exportExcelFileName)"
                  title="Выгрузить таблицу в Excel"
                >
                  <b-icon icon="cloud-upload" scale="1.2" variant="secondary"></b-icon>
                </button>
              </div>
            </div>
            <div class="bdr-result-table mt-2 mb-3" v-if="bdr.length !== 0">
              <Bdr2026Table :bdr="bdr" :months="months" :year="selected.year" :export-mode="isExportData" />
            </div>
            <p v-else-if="loading" class="mt-5 text-muted">Загрузка...</p>
            <p v-else class="mt-5 text-muted">Нет данных. Добавьте статьи в <router-link to="/budget-2026/dictionary">словаре</router-link>.</p>
          </b-card-text>
        </b-tab>
        <b-tab title="Загрузка данных">
          <b-card-text>
            <div class="bdr-results-head bdr2026-results-head">
              <div><h5>Загрузка данных за {{ months[selected.month - 1] }}, {{ selected.year }} год</h5></div>
              <div class="bdr2026-head-controls">
                <button
                  v-if="prevFiles.length > 0"
                  class="btn btn-primary bdr2026-head-btn bdr2026-head-btn-icon"
                  @click="addingFiles = !addingFiles"
                >
                  <b-icon icon="file-plus"></b-icon>
                </button>
                <button
                  class="btn btn-secondary bdr2026-head-btn-text"
                  @click="clearMonth()"
                  v-if="prevFiles.length > 0"
                >
                  Очистить
                </button>
                <button
                  v-if="prevFiles.length > 0"
                  class="btn btn-secondary bdr2026-head-btn-recalc"
                  @click="recalculateAllFiles()"
                >
                  <span v-if="!recalculatingFiles">Пересчитать</span>
                  <span v-else><b-icon icon="arrow-repeat" animation="spin"></b-icon> Считаю...</span>
                </button>
                <b-form-select
                  v-model="selected.month"
                  :options="monthList"
                  size="sm"
                  class="bdr2026-head-select custom-select-height-small"
                  @change="onMonthYearChange"
                />
                <b-form-select
                  v-model="selected.year"
                  :options="yearList"
                  size="sm"
                  class="bdr2026-head-select custom-select-height-small"
                  @change="onMonthYearChange"
                />
              </div>
            </div>
            <div class="bdr-upload-documents mt-5 mb-3">
              <div class="row pl-3 pr-3 mt-3">
                <b-overlay :show="recalculatingFiles || loading" style="width: 100%;">
                  <div class="col-md-12" v-for="(item, index) in prevFiles" :key="index">
                    <div class="row list-block shadow align-items-center mb-3 list-block__download">
                      <div class="list-block_doc">
                        <a class="cursor-pointer d-block position-relative" :href="hfs + item.path" download>
                          <img :src="'/img/icon-document.svg'" style="width: 34px;">
                          <div class="list-block_doc_extention">{{ fileExtension(item.path) }}</div>
                        </a>
                      </div>
                      <div class="list-block_text ml-3">
                        <ul class="mb-0">
                          <li><span class="font-weight-bold text-uppercase text-brown ml-2">{{ item.name }}</span></li>
                        </ul>
                      </div>
                      <div class="d-flex align-items-center ml-auto">
                        <div class="list-block_action ml-3" v-if="recalcOtchet.otchet && recalcOtchet.otchet[item.name]">
                          <b-button v-b-toggle="'b2026-' + item.name" class="m-1">
                            История ({{ numberOfFights(item.name) }} / {{ numberOfFaults(item.name) }})
                          </b-button>
                        </div>
                        <div class="list-block_action ml-3">
                          <a :href="hfs + item.path" download class="list-block_icon cursor-pointer p-1">
                            <i class="fas fa-download"></i>
                          </a>
                        </div>
                        <div class="list-block_action ml-3">
                          <span class="list-block_icon cursor-pointer p-1" @click="recalcOneFile(item)" title="Пересчитать этот файл">
                            <i class="fas fa-redo-alt"></i>
                          </span>
                        </div>
                        <div class="list-block_action ml-3">
                          <span class="list-block_icon cursor-pointer p-1" @click="deleteFile(item)">
                            <i class="far fa-trash-alt"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div v-if="recalcOtchet.otchet && recalcOtchet.otchet[item.name]">
                      <b-collapse :id="'b2026-' + item.name">
                        <b-table-simple hover small responsive class="table-otchet-of-import">
                          <b-tr
                            v-for="(row, r_index) in recalcOtchet.otchet[item.name]"
                            :key="r_index"
                            :variant="variantByResult(row.result)"
                          >
                            <b-td>{{ r_index }}</b-td>
                            <template v-for="(column, c_index) in row">
                              <b-td
                                v-if="c_index !== 'result' && c_index !== 'fault' && c_index !== 'fight' && c_index !== 'is-white-row'"
                                :key="c_index"
                              >
                                {{ column }}
                              </b-td>
                            </template>
                            <b-td class="text-center" style="width: 120px;">
                              <template v-if="row.result === 'done'">
                                <b-icon title="Успешно обработано" icon="check-square" scale="2" variant="success"></b-icon>
                              </template>
                              <template v-else-if="row.fight">
                                <b-icon title="Необходимо решить конфликт свойств" icon="info-circle-fill" scale="2" variant="info"></b-icon>
                              </template>
                              <template v-else-if="row.fault && row.fault.error_type === 'no_prop_in_1c_dictionary'">
                                <b-icon :title="row.fault.message" icon="exclamation-triangle-fill" scale="2" variant="danger"></b-icon>
                              </template>
                              <template v-else-if="row.result === 'pass'">
                                <b-icon title="Строка пропущена" icon="dash" scale="2" variant="secondary"></b-icon>
                              </template>
                              <template v-else>
                                <b-icon title="Ошибка" icon="x-circle" scale="2" variant="danger"></b-icon>
                              </template>
                            </b-td>
                            <b-td class="bdr2026-row-actions">
                              <b-button
                                v-if="(row.result === 'done' || row.fight || (row.fault && row.fault.error_type === 'no_prop_in_1c_dictionary')) && hasNumericValue(row)"
                                variant="secondary"
                                size="sm"
                                class="ml-1 bdr2026-action-btn bdr2026-action-btn-edit"
                                @click="solveProblem(row.fight || [], row[0], item.name, r_index, row, true, row.fault)"
                                title="Изменить свойство"
                              >
                                <b-icon icon="pencil-square"></b-icon>
                              </b-button>
                              <b-button
                                v-if="hasNumericValue(row)"
                                variant="outline-secondary"
                                size="sm"
                                class="ml-1 bdr2026-action-btn bdr2026-action-btn-recalc"
                                @click="recalcOneRow(item.name, r_index)"
                                title="Пересчитать строку"
                              >
                                <b-icon icon="arrow-repeat"></b-icon>
                              </b-button>
                              <b-button
                                v-if="hasNumericValue(row) && row.result !== 'pass'"
                                variant="outline-secondary"
                                size="sm"
                                class="ml-1 bdr2026-action-btn"
                                @click="markRowPass(item.name, r_index)"
                                title="Пропустить строку"
                              >
                                Пропустить
                              </b-button>
                              <b-button
                                v-if="hasNumericValue(row) && row.result === 'pass'"
                                variant="outline-primary"
                                size="sm"
                                class="ml-1 bdr2026-action-btn"
                                @click="revertRowPass(item.name, r_index)"
                                title="Вернуть строку"
                              >
                                Вернуть
                              </b-button>
                            </b-td>
                          </b-tr>
                        </b-table-simple>
                      </b-collapse>
                    </div>
                  </div>
                </b-overlay>
              </div>
              <div v-if="addingFiles">
                <tsoft-upload-area @changed="addFiles" />
              </div>
            </div>
            <div class="text-center my-5" v-if="hasFiles && addingFiles">
              <button class="btn btn-lg btn-primary" style="height: 50px;" @click="startLoadingFiles()">
                Загрузить файлы
              </button>
            </div>
            <p v-if="prevFiles.length === 0 && !hasFiles" class="mt-3 text-muted">Нет загруженных файлов за выбранный месяц. Добавьте файлы или выберите другой месяц.</p>
          </b-card-text>
        </b-tab>
        <Bdr2026SolveConflicts
          ref="solveConflicts"
          :is-open.sync="openSolveConflicts"
          :conflict.sync="conflict"
          :year="selected.year"
          :month="selected.month"
          :unit="selected.unit"
          :refresh-trigger="refreshConflictListTrigger"
          @update-otchet="updateOtchet"
          @open-add-property="onOpenAddProperty"
          @recalc-row="onRecalcRow"
        />
        <Bdr2026OneCSidebar
          :is-open.sync="openAddPropTo1C"
          :edited-item.sync="editedAddPropTo1C"
          :unit="selected.unit"
          @update-item="onUpdateItemFromFault"
        />
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  API_BDR2026,
  API_BDR2026_FIND_FILES,
  API_BDR2026_IMPORT,
  API_BDR2026_RECALCULATE_FILES,
  API_BDR2026_RECALC_ONE_ROW,
  API_BDR2026_SAVE_ONE_ELEMENT,
  API_BDR2026_HISTORY_IMPORT,
  HOST_FOR_STORAGE
} from '@/constants';
import { excelExportHelpers } from '@/mixins';
import Bdr2026Table from '@/components/bdrPage/Bdr2026Table.vue';
import Bdr2026SolveConflicts from '@/components/bdrPage/Bdr2026SolveConflicts.vue';
import Bdr2026OneCSidebar from '@/components/bdrPage/Bdr2026OneCSidebar.vue';

export default {
  name: 'BDR2026',
  components: { Bdr2026Table, Bdr2026SolveConflicts, Bdr2026OneCSidebar },
  mixins: [excelExportHelpers],
  data() {
    return {
      loading: false,
      hfs: HOST_FOR_STORAGE || '',
      bdr: [],
      selected: {
        year: Math.max(2026, new Date().getFullYear()),
        unit: 'B2B',
        month: 1
      },
      unitOptions: [
        { text: 'Танаис B2C', value: 'B2C' },
        { text: 'Танаис B2B', value: 'B2B' },
        { text: 'БСЗ', value: 'БСЗ' }
      ],
      months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      files: new FormData(),
      hasFiles: false,
      prevFiles: [],
      addingFiles: true,
      recalculatingFiles: false,
      recalcOtchet: {},
      openSolveConflicts: false,
      conflict: { list: [], name: '', file_name: '', r_index: -1 },
      refreshConflictListTrigger: 0,
      openAddPropTo1C: false,
      editedAddPropTo1C: {}
    };
  },
  computed: {
    yearList() {
      const currentYear = new Date().getFullYear();
      const startYear = 2026;
      const yearsArray = [];
      for (let year = startYear; year <= currentYear + 1; year++) {
        yearsArray.push({ text: year, value: year });
      }
      return yearsArray;
    },
    monthList() {
      return this.months.map((month, index) => ({
        text: month,
        value: index + 1
      }));
    },
    exportExcelFileName() {
      return `Бюджет ${this.selected.year} ${this.selected.unit}`;
    }
  },
  watch: {
    selected: {
      deep: true,
      handler() {
        this.recalcOtchet = {};
        this.findPrevFiles();
        this.recalculateFiles(0, true);
      }
    },
    openAddPropTo1C(nowOpen, wasOpen) {
      if (wasOpen && !nowOpen && this.openSolveConflicts) {
        setTimeout(() => {
          this.refreshConflictListTrigger += 1;
        }, 350);
      }
    }
  },
  mounted() {
    this.getBDR();
    this.findPrevFiles();
    this.recalculateFiles(0, true);
  },
  methods: {
    getBDR() {
      this.loading = true;
      axios.get(`${API_BDR2026}?unit=${this.selected.unit}&year=${this.selected.year}`).then(({ data }) => {
        this.bdr = data;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    findPrevFiles() {
      axios.get(`${API_BDR2026_FIND_FILES}?year=${this.selected.year}&month=${this.selected.month}`).then(({ data }) => {
        this.prevFiles = data || [];
        if ((this.prevFiles || []).length > 0) {
          this.addingFiles = false;
        } else {
          this.addingFiles = true;
        }
      }).catch(() => {
        this.prevFiles = [];
        this.addingFiles = true;
      });
    },
    onMonthYearChange() {
      this.findPrevFiles();
      this.recalculateFiles(0, true);
    },
    recalculateAllFiles() {
      if (!confirm('Пересчитать все файлы? Ручные решения по конфликтам нужно будет задать заново.')) {
        return;
      }
      this.recalculatingFiles = true;
      const url = `${API_BDR2026_RECALCULATE_FILES}?year=${this.selected.year}&month=${this.selected.month}&isReset=1&isAddingFiles=0`;
      axios.get(url)
        .then(({ data }) => {
          this.recalcOtchet = data && typeof data === 'object' ? { ...data } : {};
          this.getBDR();
        })
        .catch(() => {
          this.$bvToast && this.$bvToast.toast('Ошибка пересчёта', { variant: 'danger', title: 'Бюджет' });
        })
        .finally(() => {
          this.recalculatingFiles = false;
        });
    },
    // isAddingFilesMode: true только после загрузки новых файлов (startLoadingFiles).
    // Иначе при обновлении/смене месяца передаём 0 и берём кэш истории — иначе API вернёт пустой otchet и пропадут кнопки «История».
    recalculateFiles(isReset = 0, isSilent = false, isAddingFilesMode = false) {
      if (isReset && !isSilent && !confirm('Вы уверены? Это перезапишет историю загрузки и конфликты нужно будет решать заново.')) {
        return;
      }
      this.recalculatingFiles = true;
      const isAddingFiles = isAddingFilesMode && (this.prevFiles || []).length > 0 && isReset === 0 ? 1 : 0;
      axios.get(`${API_BDR2026_RECALCULATE_FILES}?year=${this.selected.year}&month=${this.selected.month}&isReset=${isReset}&isAddingFiles=${isAddingFiles}`).then(({ data }) => {
        this.recalcOtchet = data && typeof data === 'object' ? { ...data } : {};
        this.getBDR();
        this.recalculatingFiles = false;
      }).catch(() => {
        this.recalculatingFiles = false;
      });
    },
    addFiles(fileList) {
      const formData = new FormData();
      this.hasFiles = !!(fileList && fileList.length);
      if (fileList && fileList.length) {
        for (let i = 0; i < fileList.length; i++) {
          formData.append('files[' + i + ']', fileList[i]);
        }
      }
      this.files = formData;
    },
    startLoadingFiles() {
      const config = { headers: { 'content-type': 'multipart/form-data' } };
      this.files.append('year', this.selected.year);
      this.files.append('month', this.selected.month);
      const isAdding = (this.prevFiles || []).length > 0;
      axios.post(API_BDR2026_IMPORT, this.files, config).then(() => {
        this.files = new FormData();
        this.hasFiles = false;
        this.findPrevFiles();
        this.getBDR();
        this.recalculateFiles(0, false, true);
      }).catch(err => console.error(err));
    },
    clearMonth() {
      if (!confirm('Очистить файлы за выбранный месяц?')) return;
      axios.post(`${API_BDR2026}/clear-month`, {
        year: this.selected.year,
        month: this.selected.month
      }).then(() => {
        this.findPrevFiles();
        this.recalcOtchet = {};
        this.getBDR();
      }).catch(err => console.error(err));
    },
    recalcOneFile(item) {
      if (!confirm('Пересчитать только этот файл? Ручные решения по нему будут сброшены.')) return;
      axios.post(`${API_BDR2026}/recalc-one-file`, {
        file_name: item.name,
        year: this.selected.year,
        month: this.selected.month
      }).then(() => {
        this.findPrevFiles();
        this.recalculateFiles(0, false, true);
      }).catch(err => console.error(err));
    },
    deleteFile(item) {
      if (!confirm('Удалить файл из загрузки?')) return;
      axios.post(`${API_BDR2026}/delete-one-file`, {
        path: item.path,
        file_name: item.name,
        year: this.selected.year,
        month: this.selected.month
      }).then(() => {
        this.findPrevFiles();
        this.getBDR();
        this.recalculateFiles(0, false);
      }).catch(err => console.error(err));
    },
    numberOfFaults(fileName) {
      return this.recalcOtchet.faults && this.recalcOtchet.faults[fileName]
        ? Object.keys(this.recalcOtchet.faults[fileName]).length
        : 0;
    },
    numberOfFights(fileName) {
      return this.recalcOtchet.fights && this.recalcOtchet.fights[fileName]
        ? Object.keys(this.recalcOtchet.fights[fileName]).length
        : 0;
    },
    variantByResult(result) {
      if (result === 'pass') return 'light';
      if (result === 'error') return 'danger';
      if (result === 'done') return 'success';
      return 'light';
    },
    hasNumericValue(row) {
      if (!row || typeof row !== 'object') return false;
      for (let i = 0; i <= 10; i++) {
        if (typeof row[i] === 'number' && row[i] !== 0) return true;
      }
      return false;
    },
    solveProblem(fightList, name, fileName, rIndex, row, solveWithoutPredictions = false, fault = null) {
      this.conflict = {
        list: Array.isArray(fightList) ? fightList : [],
        name: name || row[0],
        file_name: fileName,
        r_index: rIndex,
        fault: fault || (row && row.fault) || null
      };
      this.openSolveConflicts = true;
    },
    recalcOneRow(fileName, rIndex) {
      axios.post(API_BDR2026_RECALC_ONE_ROW, {
        file_name: fileName,
        file_row: rIndex,
        year: this.selected.year,
        month: this.selected.month
      }).then(({ data }) => {
        this.recalcOtchet = data;
        this.getBDR();
      }).catch(err => {
        this.$bvToast && this.$bvToast.toast((err.response && err.response.data && err.response.data.error) || 'Ошибка пересчёта', { variant: 'danger', title: 'Бюджет' });
      });
    },
    revertRowPass(fileName, rIndex) {
      this.recalcOneRow(fileName, rIndex);
    },
    updateOtchet(fileName, rIndex) {
      // After save-one-element backend has updated history; refetch report with isAddingFiles=0 to get cached file_data
      this.recalculatingFiles = true;
      const url = `${API_BDR2026_RECALCULATE_FILES}?year=${this.selected.year}&month=${this.selected.month}&isReset=0&isAddingFiles=0`;
      axios.get(url)
        .then(({ data }) => {
          this.recalcOtchet = data && typeof data === 'object' ? { ...data } : {};
          this.getBDR();
        })
        .catch(() => {
          this.$bvToast && this.$bvToast.toast('Не удалось обновить отчёт', { variant: 'warning', title: 'Бюджет' });
        })
        .finally(() => {
          this.recalculatingFiles = false;
        });
    },
    addPropTo1CDictionary(fault, fileName, rIndex) {
      this.editedAddPropTo1C = {
        fault,
        name_from_file: fault.name_from_file,
        file_name: fileName,
        r_index: rIndex,
        value: fault.value,
        always_pass: 0,
        bdr2026_dictionary_id: null,
        unit_percent: '100%B2B'
      };
      this.openAddPropTo1C = true;
    },
    onOpenAddProperty(conflict) {
      if (!conflict || !conflict.file_name || conflict.r_index === undefined) return;
      const fault = conflict.fault || {};
      this.editedAddPropTo1C = {
        fault,
        name_from_file: fault.name_from_file || conflict.name || '',
        file_name: conflict.file_name,
        r_index: conflict.r_index,
        value: fault.value != null ? fault.value : 0,
        always_pass: 0,
        bdr2026_dictionary_id: null,
        unit_percent: '100%B2B'
      };
      this.openAddPropTo1C = true;
    },
    onRecalcRow(conflict) {
      if (!conflict || !conflict.file_name || conflict.r_index === undefined) return;
      this.openSolveConflicts = false;
      this.recalcOneRow(conflict.file_name, conflict.r_index);
    },
    onUpdateItemFromFault(editedItem, newRecord) {
      if (!editedItem.file_name || editedItem.r_index === undefined || !newRecord) return;
      const priznak = this.parseUnitPercent(newRecord.unit_percent || '100%B2B');
      const addBdr = {
        bdr2026_dictionary_id: newRecord.bdr2026_dictionary_id,
        value: editedItem.fault ? editedItem.fault.value : 0,
        priznak,
        file_name: editedItem.file_name,
        file_row: editedItem.r_index,
        year: this.selected.year,
        month: this.selected.month
      };
      this.loading = true;
      axios.post(API_BDR2026_SAVE_ONE_ELEMENT, { addBdr }).then(() => {
        this.updateOtchet(editedItem.file_name, editedItem.r_index);
        this.recalculateFiles(0, true);
        this.getBDR();
        this.openAddPropTo1C = false;
        this.refreshConflictListTrigger += 1;
      }).finally(() => {
        this.loading = false;
      });
    },
    parseUnitPercent(str) {
      const parts = (str || '').trim().split(',');
      const result = [];
      parts.forEach(p => {
        const [perc, unit] = p.split('%');
        result.push({ perc: perc ? parseFloat(perc) : 100, unit: (unit || 'B2B').trim() });
      });
      return result.length ? result : [{ perc: 100, unit: 'B2B' }];
    },
    markRowPass(fileName, rIndex) {
      if (!this.recalcOtchet.otchet || !this.recalcOtchet.otchet[fileName] || this.recalcOtchet.otchet[fileName][rIndex] === undefined) return;
      const row = this.recalcOtchet.otchet[fileName][rIndex];
      const { fight, fault, ...rest } = row;
      const newRow = { ...rest, result: 'pass' };
      this.$set(this.recalcOtchet.otchet[fileName], rIndex, newRow);
      if (this.recalcOtchet.fights && this.recalcOtchet.fights[fileName]) {
        const fightsFile = { ...this.recalcOtchet.fights[fileName] };
        delete fightsFile[rIndex];
        this.$set(this.recalcOtchet.fights, fileName, fightsFile);
      }
      if (this.recalcOtchet.faults && this.recalcOtchet.faults[fileName]) {
        const faultsFile = { ...this.recalcOtchet.faults[fileName] };
        delete faultsFile[rIndex];
        this.$set(this.recalcOtchet.faults, fileName, faultsFile);
      }
      axios.post(API_BDR2026_HISTORY_IMPORT, {
        year: this.selected.year,
        month: this.selected.month,
        file_data: this.recalcOtchet
      }).then(() => {
        this.getBDR();
        this.$bvToast && this.$bvToast.toast('Строка помечена как пропуск', { variant: 'success', title: 'Бюджет' });
      });
    },
    fileExtension(path) {
      if (!path) return '';
      const parts = path.split('.');
      return parts.length > 1 ? parts.pop().toUpperCase() : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.bdr2026-results-head {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.bdr2026-head-controls {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  margin-left: auto;
}
.bdr2026-head-btn-icon {
  width: 37px;
  min-width: 37px;
  height: 30px;
  padding: 0;
}
.bdr2026-head-btn-text {
  min-width: 100px;
  height: 30px;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  white-space: nowrap;
}
.bdr2026-head-btn-recalc {
  min-width: 140px;
  height: 30px;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  white-space: nowrap;
}
.bdr2026-head-select {
  min-width: 130px;
}
.bdr2026-row-actions {
  min-width: 220px;
  text-align: right;
}
.bdr2026-action-btn {
  min-width: 100px;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  white-space: nowrap;
}
.fix-error.bdr2026-action-btn {
  display: inline-block;
  min-width: 120px;
  padding: 0.25rem 0.5rem;
  margin-right: 0.25rem;
  margin-bottom: 0.25rem;
  cursor: pointer;
  text-align: center;
}
.bdr2026-action-btn-recalc,
.bdr2026-action-btn-edit {
  min-width: 30px;
  max-width: 30px;
}
/* Кнопка выгрузки в Excel (облочко), как в старом Бюджете */
.bdr2026-export-btn.bdr-results-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background: #fff;
  cursor: pointer;
  padding: 0;
}
.bdr2026-export-btn.bdr-results-button:hover:not(:disabled) {
  background-color: #f8f9fa;
  border-color: #adb5bd;
}
.bdr2026-export-btn.bdr-results-button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
</style>
